/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JsonNode } from './JsonNode';
export type AiModelRequest = {
    modelName: string;
    providerName: string;
    type: AiModelRequest.type;
    settings?: JsonNode;
    settingsValidationSchema?: JsonNode;
    uiSchema?: JsonNode;
};
export namespace AiModelRequest {
    export enum type {
        LLM = 'LLM',
        TTS = 'TTS',
        STT = 'STT',
    }
}

